module.exports = __webpack_public_path__ + "img/logo.bd151b9.png";